<wiz-vgroup #vgEdition wizValidationContainer
  width="100%" height="100%" gap="2" class="section-container">
  <wiz-hgroup width="100%" verticalAlign="center" horizontalAlign="end">
    <!-- <wiz-label #lbTitle width="100%" class="titleLabel"></wiz-label> -->
    <wiz-icon class="image-purple" (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>


  <wiz-hgroup wizValidationContainer width="100%" verticalAlign="center">
    <!-- objet -->
    <wiz-text-input #tiObj width="100%" [wizLabel]="'$.workflow.obj.$'"></wiz-text-input>
    
    <wiz-icon #icoAdd [visible]='exist && message' class="image-purple"
    style="cursor: pointer;" [wizTooltip]="'$.wf.addreply.$'" (click)="doAddReply()">add</wiz-icon>   
    
  </wiz-hgroup>

  <wiz-dropdown [visible]='!exist && message'
          #ddState
          width="120px"
          [wizLabelField]="'trsLabel'"
          [wizLabel]="'$.wf.state.$'"
    ></wiz-dropdown>

  <wiz-hgroup wizValidationContainer width="100%" [visible]='!exist && message'>
    <wiz-datefield #daStart [wizLabel]="'$.wf.startdate.$'"></wiz-datefield>
    <wiz-datefield #daEnd [wizLabel]="'$.wf.enddate.$'"></wiz-datefield>
  </wiz-hgroup>
  

  <wiz-text-area #taContent wizShowLabel="false" [visible]='!exist && message'
  width="100%" height="80px" wizValidator
  [wizMaxChars]="2000"></wiz-text-area>   

  <wiz-list #lst [visible]='message'
    [wizDataProvider]="messageDS"
    height="100%"
    width="100%"
    itemHeight="100"
    [wizItemRenderer]="renderer"
  ></wiz-list>
  



  <wiz-hgroup wizValidationContainer width="100%" height="100%" [visible]='file'>
        <wiz-group #dropGrp width="330px" height="330px">
          <wiz-vgroup #dropEmpty class="dropZone" *ngIf="!dropFull"
            width="100%" height="100%" horizontalAlign="center" verticalAlign="center"
            (click)="selectFile()" (drop)="dropFile($event)" (dragover)="dover($event)">
            
            <wiz-icon #icoAddFile [wizTooltip]="'$.common.import.$'">upload</wiz-icon>
            <wiz-label wizLabel="$.common.free.drop.message.$"></wiz-label>
          </wiz-vgroup>
          
          <wiz-hgroup #dropFull class="dropZone" *ngIf="dropFull" 
          horizontalAlign="center" verticalAlign="center" style="padding: 5px;"
          width="100%" height="100%">
            <wiz-label [wizLabel]="mediaReference?.shortFileName" [wizTooltip]="mediaReference.fileName" width="100%"
            style="word-break: break-all;"></wiz-label>
            <wiz-vgroup width="28px">
              <wiz-icon #icoDelFile
              style="cursor: pointer; font-size: 20px"
              (click)="clearDropFile()"
              [wizTooltip]="'$.common.delete.$'">delete</wiz-icon>
              <wiz-icon #icoLoadFile 
              [undisableable]="true"
              style="cursor: pointer; font-size: 20px" (click)="loadDropFile()" [wizTooltip]="'$.common.export.$'">download</wiz-icon>
            </wiz-vgroup>
          </wiz-hgroup>
        </wiz-group>
  </wiz-hgroup>

  <wiz-hgroup wizValidationContainer width="100%" height="100%" [visible]='media'>
        <wiz-group #imgGp  width="330px" height="330px">
          <wiz-vgroup gap="0" width="100%" height="100%">
            <wiz-label #imgLbl  
            [wizLabel]="'$.workflow.media.$'"
            class="componentLabel"></wiz-label>
            <wiz-vgroup gap="0" width="100%" height="100%" horizontalAlign="center" verticalAlign="center">
              <wiz-image style="object-fit: contain;"
                #img
                tabindex="0"
                height="100%"
                width="100%"
                class="img-picker img-freestyle"
                [useHandCursor]="true"
                [sourceObservable]="imgSrcObs"
                [useHandCursor]="true"
                (keydown)="keydownForUpload($event)"
                wizholdable
                (wizTap)="clickForUpload($event)"
                (wizHold)="seeImage($event)">
                
              </wiz-image>
            </wiz-vgroup>
            
          </wiz-vgroup>
          <wiz-hgroup width="100%" horizontalAlign="end">
            <wiz-icon
              [visible]="hasImage"
              style="cursor: pointer; font-size: 20px"
              (click)="clearImage()"
              class="image-back-white"
              [wizTooltip]="'$.common.delete.$'"
              >delete</wiz-icon>
          </wiz-hgroup>
          
        </wiz-group>
  </wiz-hgroup>  

    

  <!-- <wiz-list #liKey width="100%" height="100%" [wizLabelField]="'fullStr'" [wizDataProvider]="mainDS"></wiz-list> -->
  <wiz-hgroup width="100%" gap="2" verticalAlign="center" style="padding: 3px;">
    <wiz-icon class="image-purple" (click)="do('message')"><mat-icon>message</mat-icon></wiz-icon>
    <wiz-icon class="image-purple" (click)="do('recipient')"><mat-icon>group_add</mat-icon></wiz-icon>
    <wiz-icon [ngClass]="hasFileClass" (click)="do('file')"><mat-icon>attach_file</mat-icon></wiz-icon>
    <wiz-icon [ngClass]="hasMediaClass" (click)="do('media')"><mat-icon>image</mat-icon></wiz-icon>

    <wiz-spacer width="100%"></wiz-spacer>

    <wiz-icon class="image-back-orange" (click)="askForDelete()" 
    [wizTooltip]="'$.common.delete.$'" tooltipPlacement="left">delete</wiz-icon>
    
    <wiz-spacer width="100%"></wiz-spacer>

    <wiz-button
      #btnSave [wizDisabled]="disableButtons()"
      [wizLabel]="'$.common.save.$'"
      [wizIcon]="'icon-arrow-right'"
      (click)="doMerge()"
      [iconPlacement]="'right'"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
